import { getApiUrl } from "@lib/utils";
import { useQuery } from "@tanstack/react-query";

export interface DashboardStats {
  total_tabs: number;
  total_users: number;
  total_artists: number;
  pending_submissions: number;
}

function getAuthToken(): string | null {
  return localStorage.getItem("admin_token");
}

async function fetchDashboardStats(): Promise<DashboardStats> {
  const token = getAuthToken();
  if (!token) {
    throw new Error("No authentication token found");
  }
  const apiUrl = getApiUrl();
  const response = await fetch(`${apiUrl}/admin/dashboard/stats?token=${token}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!response.ok) {
    throw new Error("Failed to fetch dashboard stats");
  }
  return response.json();
}

export function useDashboardStats() {
  return useQuery<DashboardStats, Error>({
    queryKey: ["dashboard-stats"],
    queryFn: fetchDashboardStats,
  });
}

